'use client';

import { useContentfulLiveUpdates } from '@contentful/live-preview/react';

import { CollectionContent } from '@/modules/product/components/collection/CollectionContent';
import { CollectionHeader } from '@/modules/product/components/collection/CollectionHeader';
import { useCollectionPageView } from '@/modules/product/hooks/useCollectionPageView';
import { useFilteredCollectionProducts } from '@/modules/product/hooks/useFilteredCollectionProducts';
import { ContentfulCollection } from '@/modules/product/models/collection.interface';

type CollectionPageContentProps = {
  collection: ContentfulCollection;
};

export default function CollectionPageContent({ collection }: CollectionPageContentProps) {
  const liveCollection = useContentfulLiveUpdates(collection);
  const filteredProducts = useFilteredCollectionProducts(liveCollection?.products);
  const skus = filteredProducts?.map((product) => product.sku) || [];

  useCollectionPageView(liveCollection);

  return (
    <main
      className="mx-auto max-w-[100vw] py-6 lg:max-w-[1920px] lg:pb-10 lg:pt-8"
      data-collection-roomtype={liveCollection?.roomType || ''}
      data-collection-type="editorial"
    >
      <CollectionHeader collection={liveCollection} />
      <CollectionContent collection={liveCollection} productSkus={skus} />
    </main>
  );
}
